;
/**
 *  CustomToolbox
 *
 *  Hier k�nnen spezielle MapToolboxen definiert werden.
 *
 */

HafasWebapp.prototype.Controller.CustomToolbox = {
  index: function () {

    /*
     * Folgendes ist n�tig um einen neuen Toolbox Typen zu definieren:
     */

    Hafas.Modules.Maps.addToolboxType(
        "GeoFeatureMessage",
        {
          prio: 1000,
          file: 'common.map.html',
          template: 'Common_Map_ToolboxGeoFeatures',
          createData: function (rawData) {
            return rawData;
          }
        },
        function(data) {
          if(typeof data.location.geoFeatureMessage != "undefined" && data.location.geoFeatureMessage){
            return true;
          }
        }
    );

      Hafas.Modules.Maps.addToolboxType(
          "CLUSTER",
          {
              prio: 1000,
              file: 'map.flyout.html',
              template: 'Common_Flyout_Cluster_Content',
              createData: function (rawData) {
                  return rawData;
              }
          },
          function(data) {
              // Check if object is a clustered marker
              if(typeof data.location.displayType != "undefined" && data.location.displayType  == 'CLUSTER'){
                  return true;
              }
          }
      );

    Hafas.Modules.Maps.addToolboxType(
        "TPL_DEF_BOOKEE",
        {
          prio: 1000,
          file: 'map.flyout.html',
          template: 'Common_Flyout_MSP_Content',
          createData: function (rawData) {
            return rawData;
          }
        },
        function(data) {
          // Für HCI > 1.48 auf Template prüfen, ansonsten prüfen ob mcpDataType == 'V'
          if((typeof data.location.mapDtlCntStyleTemplate != "undefined" && data.location.mapDtlCntStyleTemplate.tpl == 'TPL_DEF_BOOKEE') ||
              (data.location.mcpData !== undefined && data.location.mcpData.type == 'V')){
            return true;
          }
        }
    );

    Hafas.Modules.Maps.addToolboxType(
        "TPL_DEF_PLACE",
        {
          prio: 1000,
          file: 'map.flyout.html',
          template: 'Common_Flyout_MSP_Content',
          createData: function (rawData) {
            return rawData;
          }
        },
        function(data) {
          if((typeof data.location.mapDtlCntStyleTemplate != "undefined" && data.location.mapDtlCntStyleTemplate.tpl == 'TPL_DEF_PLACE') ||
              (data.location.mcpData !== undefined && (data.location.mcpData.type == 'P' || data.location.mcpData.type == 'A'))){
            return true;
          }
        }
    );

      Hafas.Modules.Maps.addToolboxType(
          "TPL_DEF_POI",
          {
              prio: 1000,
              file: 'map.flyout.html',
              template: 'Common_Flyout_POI_Content',
              createData: function (rawData) {
                  return rawData;
              }
          },
          function(data) {
              if(typeof data.location.mapDtlCntStyleTemplate != "undefined" && data.location.mapDtlCntStyleTemplate.tpl == 'TPL_DEF_POI'){
                  return true;
              }
          }
      );



    /*
    Hafas.Modules.Maps.addToolboxType(
            "[Name/Id der Toolbox]",
            {
              Optionen:

              Hier werden die Unterschiede zur Standard MapToolbox definiert. Funktionen und Werte definieren die Funktionen und Werte der Standard Toolbox �ber. Die folgenden Werte k�nnen angegeben werden (alle optional):

              template: <String> Welchen Template soll verwendet werden
              file: <String> In welcher Datei liegt das Template
              prio: <int> In welcher Reihenfolde soll die Infobox gecheckt werden (siehe check Funktion)
              show: <Function> Die Show Funktion wird aufgerufen wenn die Toolbox angezeigt wird. Von hier aus sollte die Funktion create aufgerufen werden.
              onShow: <Function> Wird nach dem Anzeigen aufgerufen
              createData: <Function> Bereitet die Daten zum rendern in den Templates auf function(rawData) { ... return data; }
              getCoord: <Function> Gibt die Koordinaten aus dem Daten zur�ck
              onClose: <Function> Wird nach dem schlie�en der Toolbox aufgerufen
            },
            <Function> Check Funktion. Diese Funktion �berpr�ft an Hand der �bergebenen Daten ob die Toolbox f�r diese Daten verwendet werden soll.
            (Tollbox mit h�chster prio wird verwendet) Wird keine Toolbox ausgew�hlt wird die Standadtoolbox genommen.
            Beispiel:
            function(data) {
                if(data.type == 2)
                  return true;
            }
      );
      */

  }
};


